/* eslint-disable no-unused-vars */
import React from 'react';

import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import './index.mobile.en.less';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';
import Section3 from './section3';
import Section4 from './section4';

interface ITopic900Props {
  settings: any;
}

const Topic900: React.FunctionComponent<ITopic900Props> = ({ settings }) => (
  <TopicContainer className="t900">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item t900_2" id="2">
      <Section1 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item t900_3" id="3">
      <Section2 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item t900_4" id="4">
      <Section3 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item t900_5" id="5">
      <Section4 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default Topic900;
